import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchLocation } from '../Services/LocationManagement';
import { RootState } from '../store';

export const getAllLocations = createAsyncThunk(
  'location/getAllLocations',
  async () => {
    const response = await fetchLocation();
    return response?.results || [];
  }
);

interface LocationApiState {
  locationData: {
    loading: boolean;
    data: any[];
  };
}

const initialState: LocationApiState = {
  locationData: {
    loading: false,
    data: [],
  },
};

export const locationApiSlice = createSlice({
  name: 'locationApi',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllLocations.pending, (state) => {
        state.locationData.loading = true;
      })
      .addCase(getAllLocations.fulfilled, (state, action) => {
        state.locationData.data = action.payload;
        state.locationData.loading = false;
      })
      .addCase(getAllLocations.rejected, (state) => {
        state.locationData.loading = false;
      });
  },
});

export const selectLocationData = (state: RootState) =>
  state.locationApi.locationData;

export const selectLoadingLocation = (state: RootState) =>
  state.locationApi.locationData.loading;

export default locationApiSlice.reducer;
